import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["graph", "personSelect", "depthSelect", "lineageSelect", "branchSelect"]

  connect() {
    this.loadGraph()
  }

  reload() {
    this.loadGraph()
  }

  currentPersonId() {
    if (this.hasPersonSelectTarget && this.personSelectTarget.value) {
      return this.personSelectTarget.value
    }

    const match = window.location.pathname.match(/\/people\/(\d+)\/graph_explorer/)
    return match ? match[1] : ""
  }

  currentDepth() {
    if (this.hasDepthSelectTarget && this.depthSelectTarget.value) {
      return this.depthSelectTarget.value
    }

    const url = new URL(window.location.href)
    return url.searchParams.get("depth") || "2"
  }

// This gets selected overlay IDs from the checkboxes or URL:
  currentLineageIds() {
  const checkedIds = Array.from(
    document.querySelectorAll('input[name="lineage_ids[]"]:checked')
  ).map((el) => el.value)

  if (checkedIds.length > 0) return checkedIds

  const url = new URL(window.location.href)
  return url.searchParams.getAll("lineage_ids[]")
}

  lineageLabelMap() {
  const map = {}

  document.querySelectorAll('input[name="lineage_ids[]"]:checked').forEach((input) => {
    const label = document.querySelector(`label[for="${input.id}"]`)
    map[String(input.value)] = label
      ? label.textContent.trim()
      : `Lineage ${input.value}`
  })

  return map
}

// assigns colors to selected overlays:
  lineageColorMap() {
  const selectedIds = this.currentLineageIds()

        const palette = [
      { fill: "#ffffff", stroke: "#1971c2", hoverFill: "#e7f5ff", edge: "#1971c2" }, // blue
      { fill: "#ffffff", stroke: "#5f3dc4", hoverFill: "#f3f0ff", edge: "#5f3dc4" }, // purple
      { fill: "#ffffff", stroke: "#099268", hoverFill: "#e6fcf5", edge: "#099268" }, // teal-green
      { fill: "#ffffff", stroke: "#e67700", hoverFill: "#fff3bf", edge: "#e67700" }, // orange
      { fill: "#ffffff", stroke: "#0c8599", hoverFill: "#e3fafc", edge: "#0c8599" }  // cyan
    ]

  const map = {}

  selectedIds.forEach((id, index) => {
    map[String(id)] = palette[index % palette.length]
  })

  return map
}

  loadGraph() {
  const personId = this.currentPersonId()
  const depth = this.currentDepth()

  if (!personId) {
    if (this.hasGraphTarget) {
      this.graphTarget.innerHTML = `
        <div class="text-muted small p-3">
           Select a focus person, then click Apply Filters.
        </div>
      `
    }

    return
  }

  const params = new URLSearchParams()
  params.append("depth", depth)

  let url

  if (window.location.pathname === "/family_graph") {
    params.append("person_id", personId)

    if (this.hasLineageSelectTarget && this.lineageSelectTarget.value) {
      params.append("lineage_id", this.lineageSelectTarget.value)
    }

    if (this.hasBranchSelectTarget && this.branchSelectTarget.value) {
      params.append("branch", this.branchSelectTarget.value)
    }

    url = `/family_graph_data?${params.toString()}`
} else {
  this.currentLineageIds().forEach((id) => {
    params.append("lineage_ids[]", id)
  })

  url = `/people/${personId}/graph_json?${params.toString()}`
}

  fetch(url)
    .then((response) => response.json())
    .then((data) => this.render(data))
    .catch((error) => {
      if (this.hasGraphTarget) {
        this.graphTarget.innerHTML = `<pre>Graph load failed: ${error}</pre>`
      }
    })
}


  render(data) {
   
    const container = this.hasGraphTarget ? this.graphTarget : this.element

    document.querySelectorAll("body > a").forEach((link) => {
      if (link.textContent.trim() === "Open profile") {
        link.remove()
      }
    })
  
      if (this.hasGraphTarget) {
    container.innerHTML = ""
  }

    const baseWidth = container.clientWidth || 1200

    const nodesByDepthForWidth = {}
    
    data.nodes.forEach((node) => {
      const level = node.depth || 0
      nodesByDepthForWidth[level] ||= 0
      nodesByDepthForWidth[level] += 1
    })

    // const widestLevelCount = Math.max(...Object.values(nodesByDepthForWidth), 1)
    // const width = Math.max(baseWidth, widestLevelCount * 210 + 200)
    
//     const height = container.clientHeight || 700
// const width = container.clientWidth || 1200
  // svg.setAttribute("width", width)
  // svg.setAttribute("height", height)
  // svg.setAttribute("viewBox", `0 0 ${width} ${height}`)
    // const lineageColors = this.lineageColorMap()
    const widestLevelCount = Math.max(...Object.values(nodesByDepthForWidth), 1)
    const width = Math.max(baseWidth, widestLevelCount * 300 + 400, 1800)
    const height = Math.max(container.clientHeight || 700, 900)

    const lineageColors = this.lineageColorMap()
    
  // --- LEGEND START ---
      let legend = document.createElement("div")
      legend.style.display = "flex"
      legend.style.flexWrap = "wrap"
      legend.style.gap = "8px"
      legend.style.marginBottom = "10px"
      legend.style.fontSize = "12px"
      legend.style.background = "#16a7c5"
      legend.style.padding = "10px"

      const lineageLabels = this.lineageLabelMap()

Object.keys(lineageColors).forEach((lineageId) => {
  const colors = lineageColors[lineageId]

  const item = document.createElement("div")
  item.style.display = "flex"
  item.style.alignItems = "center"
  item.style.gap = "6px"
  item.style.padding = "4px 8px"
  item.style.border = "1px solid #dee2e6"
  item.style.borderRadius = "6px"
  item.style.background = "#fff"

  const swatch = document.createElement("span")
  swatch.style.display = "inline-block"
  swatch.style.width = "12px"
  swatch.style.height = "12px"
  swatch.style.borderRadius = "3px"
  swatch.style.background = colors.fill
  swatch.style.border = `2px solid ${colors.stroke}`

  const label = document.createElement("span")
  label.textContent = lineageLabels[lineageId] || `Lineage ${lineageId}`

  item.appendChild(swatch)
  item.appendChild(label)
  legend.appendChild(item)
})
// --- LEGEND END ---


// multi-lineage indicator
const multi = document.createElement("div")
multi.style.display = "flex"
multi.style.alignItems = "center"
multi.style.gap = "6px"
multi.style.padding = "4px 8px"
multi.style.border = "1px solid #dee2e6"
multi.style.borderRadius = "6px"
multi.style.background = "#fff"

const multiSwatch = document.createElement("span")
multiSwatch.style.width = "12px"
multiSwatch.style.height = "12px"
multiSwatch.style.borderRadius = "3px"
multiSwatch.style.background = "#fff3cd"
multiSwatch.style.border = "2px solid #16a7c5"

const multiLabel = document.createElement("span")
multiLabel.textContent = "Multiple lineages"

multi.appendChild(multiSwatch)
multi.appendChild(multiLabel)

legend.appendChild(multi)

    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg")


    svg.setAttribute("width", width)
    svg.setAttribute("height", height)
    svg.setAttribute("viewBox", `0 0 ${width} ${height}`)
    svg.setAttribute("preserveAspectRatio", "xMidYMid meet")
    svg.style.cursor = "grab"
    svg.style.width = `${width}px`
    svg.style.height = `${height}px`

  //  this.fitGraphToVisibleContent(container)

  //  all nodes + edges go inside g
    const g = document.createElementNS("http://www.w3.org/2000/svg", "g")
    svg.appendChild(g)

    let scale = 1
    let translateX = 0
    let translateY = 0

    const updateTransform = () => {
      g.setAttribute("transform", `translate(${translateX}, ${translateY}) scale(${scale})`)
    }


    let isDragging = false
    let dragMoved = false
    let startX = 0
    let startY = 0

    const tooltip = document.createElement("div")
    tooltip.style.position = "fixed"
    tooltip.style.display = "none"
    tooltip.style.pointerEvents = "none"
    tooltip.style.background = "#fff"
    tooltip.style.border = "1px solid #ccc"
    tooltip.style.borderRadius = "6px"
    tooltip.style.padding = "8px 10px"
    tooltip.style.fontSize = "12px"
    tooltip.style.lineHeight = "1.4"
    tooltip.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)"
    tooltip.style.zIndex = "9999"
    tooltip.style.maxWidth = "260px"
    document.body.appendChild(tooltip)

const showTooltip = (event, node) => {
  tooltip.innerHTML = `
    <strong>${node.display_name || ""}</strong><br>
    ${node.life_dates || ""}
    ${node.birth_place ? `<br>Born: ${node.birth_place}` : ""}
    ${node.death_place ? `<br>Died: ${node.death_place}` : ""}
  `

  tooltip.style.display = "block"
  tooltip.style.left = `${event.clientX + 12}px`
  tooltip.style.top = `${event.clientY + 12}px`
}


const moveTooltip = (event) => {
  // tooltip.style.left = `${event.clientX + 12}px`
  // tooltip.style.top = `${event.clientY + 12}px`
}


const hideTooltip = () => {
  tooltip.style.display = "none"
}


    const nodePositions = {}
    const hasDepth = data.nodes.some((node) => node.depth !== undefined && node.depth !== null)

    if (hasDepth) {
      const levels = {}

    data.nodes.forEach((node) => {
      const level = node.depth || 0
      levels[level] ||= []
      levels[level].push(node)
    })

      const sortedLevels = Object.keys(levels).map(Number).sort((a, b) => a - b)
      const maxLevel = Math.max(...sortedLevels)

      // CP 73
      // const topPadding = 80
      // const bottomPadding = 180
      // const usableHeight = Math.max(300, height - topPadding - bottomPadding)
      // const levelSpacingY = maxLevel > 0 ? usableHeight / maxLevel : usableHeight / 2

      // CP 95 
      const topPadding = 80
      const bottomPadding = 180
      const minLevelSpacingY = 150

      const requestedUsableHeight = Math.max(300, height - topPadding - bottomPadding)
      const usableHeight =
        maxLevel > 0
          ? Math.max(requestedUsableHeight, maxLevel * minLevelSpacingY)
          : requestedUsableHeight

        const layoutHeight = topPadding + usableHeight + bottomPadding
        // svg.setAttribute("height", layoutHeight)
        svg.setAttribute("height", layoutHeight)
        svg.style.height = `${layoutHeight}px`

        const levelSpacingY = maxLevel > 0 ? usableHeight / maxLevel : usableHeight / 2

              // const sidePadding = 80
              // const usableWidth = Math.max(300, width - sidePadding * 2)
              // const centerX = width / 2
// CP95
              const sidePadding = 160
              const widestLevelCount = Math.max(
                ...sortedLevels.map((level) => levels[level].length)
              )

              const minNodeSpacingX = 300
              const requestedUsableWidth = Math.max(300, width - sidePadding * 2)
              const usableWidth = Math.max(
                requestedUsableWidth,
                Math.min(widestLevelCount, 8) * minNodeSpacingX
              )

              const layoutWidth = sidePadding * 2 + usableWidth
              // svg.setAttribute("width", layoutWidth)
              svg.setAttribute("width", layoutWidth)
              svg.style.width = `${layoutWidth}px`

              const centerX = layoutWidth / 2
              sortedLevels.forEach((level) => {
                const nodesAtLevel = levels[level].slice().sort((a, b) => {
                // prioritize nodes that have more connections
                const aScore = (a.parent_count || 0) + (a.child_count || 0)
                const bScore = (b.parent_count || 0) + (b.child_count || 0)

                return bScore - aScore
              })
                const maxPerRow = 8
                const rowCount = Math.ceil(nodesAtLevel.length / maxPerRow)
                const baseY = topPadding + (maxLevel - level) * levelSpacingY

                nodesAtLevel.forEach((node, index) => {
                  const row = Math.floor(index / maxPerRow)
                  const col = index % maxPerRow

                  const nodesInThisRow = Math.min(
                    maxPerRow,
                    nodesAtLevel.length - row * maxPerRow
                  )

                  const spacingX = Math.min(260, usableWidth / Math.max(nodesInThisRow - 1, 1))
                  const totalWidth = spacingX * (nodesInThisRow - 1)
                  const startX = centerX - totalWidth / 2

                  const x = startX + col * spacingX

                  // stack rows slightly
                  const rowOffset = (row - (rowCount - 1) / 2) * 60
                  const y = baseY + rowOffset

                  nodePositions[node.id] = { x, y }
                })
              })
              } else {
                const spacing = 100

                data.nodes.forEach((node, index) => {
                  const x = (index % 8) * spacing + 80
                  const y = Math.floor(index / 8) * spacing + 80
                  nodePositions[node.id] = { x, y }
                })
              }

    // CP95
        // const selectedLineageIds = this.selectedLineageIds().map((id) => String(id))
        // const overlayActive = selectedLineageIds.length > 0

            let selectedLineageIds = Array.from(
              document.querySelectorAll('input[name="lineage_ids[]"]:checked')
            ).map((input) => String(input.value))

            if (selectedLineageIds.length === 0) {
              const url = new URL(window.location.href)
              selectedLineageIds = url.searchParams
                .getAll("lineage_ids[]")
                .map((id) => String(id))
            }

    const overlayActive = selectedLineageIds.length > 0

        const inSelectedOverlay = (lineageIds = []) => {
          if (!overlayActive) return true

          return lineageIds
            .map((id) => String(id))
            .some((id) => selectedLineageIds.includes(id))
        }
       const edgeElements = []

    data.edges.forEach((edge) => {
      const source = nodePositions[edge.source]
      const target = nodePositions[edge.target]
      if (!source || !target) return

      const line = document.createElementNS("http://www.w3.org/2000/svg", "line")
      line.setAttribute("x1", source.x)
      line.setAttribute("y1", source.y)
      line.setAttribute("x2", target.x)
      line.setAttribute("y2", target.y)

      // const edgeLineageCount = (edge.lineage_ids || []).length

      // line.setAttribute("stroke", edgeLineageCount > 0 ? "#9fb0bf" : "#d8dee6")
      // line.setAttribute("stroke-width", edgeLineageCount > 0 ? "1.6" : "1.2")
      // line.style.opacity = edgeLineageCount > 0 ? "0.65" : "0.35"

      // CP95
      const edgeLineageIds = edge.lineage_ids || []
      const edgeLineageCount = edgeLineageIds.length
      const edgeIsSelected = inSelectedOverlay(edgeLineageIds)

      line.setAttribute("stroke", edgeLineageCount > 0 ? "#9fb0bf" : "#d8dee6")
      line.setAttribute("stroke-width", edgeIsSelected ? "2.2" : "1.1")
      line.style.opacity = edgeIsSelected ? "0.8" : "0.12"

      const baseStroke = line.getAttribute("stroke")
      const baseStrokeWidth = line.getAttribute("stroke-width")
      const baseOpacity = line.style.opacity

      edgeElements.push({
        edge,
        line,
        baseStroke,
        baseStrokeWidth,
        baseOpacity
      })

      g.appendChild(line)
    })

    const nodeElements = {}

    data.nodes.forEach((node) => {
      const pos = nodePositions[node.id]
        if (!pos) return

        const { x, y } = pos
      const px = Math.round(x)
      const py = Math.round(y)

      const nodeGroup = document.createElementNS("http://www.w3.org/2000/svg", "g")


      const openPerson = (event) => {
        event.stopPropagation()
        window.location.href = `/people/${node.id}`
      }

      nodeGroup.style.cursor = "pointer"
      nodeGroup.addEventListener("click", openPerson)
  


      // const isRoot = !!node.root
      // const lifeDates = node.life_dates || ""
      // const cardWidth = isRoot ? 240 : 220
      // const cardHeight = lifeDates ? 72 : 52
      // const lineageCount = (node.lineage_ids || []).length

      const isRoot = !!node.root
      const lifeDates = node.life_dates || ""
      const hasImage = !!node.image_url

      const cardWidth = isRoot ? 240 : 220
      const cardHeight = hasImage ? 110 : (lifeDates ? 72 : 52)

      const lineageCount = (node.lineage_ids || []).length
      
      // CP95
      const nodeIsSelected = isRoot || inSelectedOverlay(node.lineage_ids || [])
      nodeGroup.style.opacity = nodeIsSelected ? "1" : "0.22"

      const hit = document.createElementNS("http://www.w3.org/2000/svg", "rect")
      hit.style.cursor = "pointer"
      hit.addEventListener("click", openPerson) 
      hit.setAttribute("x", px - cardWidth / 2)
      hit.setAttribute("y", py - cardHeight / 2)
      hit.setAttribute("width", cardWidth)
      hit.setAttribute("height", cardHeight)
      hit.setAttribute("rx", "10")
      hit.setAttribute("ry", "10")
      hit.setAttribute("fill", "#ffffff")
      hit.setAttribute("fill-opacity", "0")
      hit.setAttribute("pointer-events", "all")

      const circle = document.createElementNS("http://www.w3.org/2000/svg", "rect")
      circle.setAttribute("x", px - cardWidth / 2)
      circle.setAttribute("y", py - cardHeight / 2)
      circle.setAttribute("width", cardWidth)
      circle.setAttribute("height", cardHeight)
      circle.setAttribute("rx", "10")
      circle.setAttribute("ry", "10")
      circle.style.cursor = "pointer"
      circle.addEventListener("click", openPerson)

      const primaryLineageId = lineageCount === 1 ? String(node.lineage_ids[0]) : null
      const primaryColors = primaryLineageId ? lineageColors[primaryLineageId] : null

      if (isRoot) {
        circle.setAttribute("fill", "#16a7c5")
        circle.setAttribute("stroke", "#0f6f83")
        circle.setAttribute("stroke-width", "2.5")
        circle.setAttribute("filter", "drop-shadow(0 0 14px rgba(22,167,197,0.85))")

      } else if (lineageCount > 1) {
        circle.setAttribute("fill", "#ffffff")
        circle.setAttribute("stroke", "#16a7c5")
        circle.setAttribute("stroke-width", "3")
        circle.setAttribute("filter", "none")

      } else if (lineageCount === 1 && primaryColors) {
        circle.setAttribute("fill", "#ffffff")
        circle.setAttribute("stroke", primaryColors.stroke)
        circle.setAttribute("stroke-width", "3")
        circle.setAttribute("filter", "none")

      } else {
        circle.setAttribute("fill", "#ffffff")
        circle.setAttribute("stroke", "#adb5bd")
        circle.setAttribute("stroke-width", "1")
        circle.setAttribute("filter", "none")
      }

      nodeElements[node.id] = { nodeGroup, circle }

      const baseFill = circle.getAttribute("fill")


      const displayName = node.label || node.display_name || `Person ${node.id}`

      const nameParts = displayName.trim().split(/\s+/)
      let nameLines = [displayName]

      if (displayName.length > 24 && nameParts.length > 1) {
        const midpoint = Math.ceil(nameParts.length / 2)
        nameLines = [
          nameParts.slice(0, midpoint).join(" "),
          nameParts.slice(midpoint).join(" ")
        ]
      }

      // const lineHeight = 15
      // const totalTextLines = nameLines.length + (lifeDates ? 1 : 0)
      // const firstLineY = py - ((totalTextLines - 1) * lineHeight) / 2 + 5

      const lineHeight = 15
      const totalTextLines = nameLines.length + (lifeDates ? 1 : 0)

      const hasProfileImage = Boolean(node.image_url)
      const profileImageSize = isRoot ? 42 : 36
      const profileImageGap = hasProfileImage ? 7 : 0

      const textBlockHeight = totalTextLines * lineHeight
      const imageBlockHeight = hasProfileImage ? profileImageSize + profileImageGap : 0
      const totalBlockHeight = imageBlockHeight + textBlockHeight

      const imageX = px - profileImageSize / 2
      const imageY = py - totalBlockHeight / 2

      const firstLineY =
        py - totalBlockHeight / 2 + imageBlockHeight + 12

      const text = document.createElementNS("http://www.w3.org/2000/svg", "text")
      let profileImageBorder = null
      let profileImage = null

      if (hasProfileImage) {
        profileImageBorder = document.createElementNS("http://www.w3.org/2000/svg", "rect")
        profileImageBorder.setAttribute("x", imageX - 1)
        profileImageBorder.setAttribute("y", imageY - 1)
        profileImageBorder.setAttribute("width", profileImageSize + 2)
        profileImageBorder.setAttribute("height", profileImageSize + 2)
        profileImageBorder.setAttribute("rx", "6")
        profileImageBorder.setAttribute("fill", isRoot ? "#ffffff" : "#f8f9fa")
        profileImageBorder.setAttribute("stroke", isRoot ? "#ffffff" : "#ced4da")
        profileImageBorder.setAttribute("stroke-width", "1")

        profileImage = document.createElementNS("http://www.w3.org/2000/svg", "image")
        profileImage.setAttribute("href", node.image_url)
        profileImage.setAttribute("x", imageX)
        profileImage.setAttribute("y", imageY)
        profileImage.setAttribute("width", profileImageSize)
        profileImage.setAttribute("height", profileImageSize)
        profileImage.setAttribute("preserveAspectRatio", "xMidYMid slice")
      }
      text.setAttribute("x", px)
      text.setAttribute("y", firstLineY)
      text.setAttribute("text-anchor", "middle")
      text.setAttribute("font-size", isRoot ? "15" : "13")
      text.setAttribute("font-weight", isRoot ? "700" : "600")
      text.setAttribute("fill", isRoot ? "#ffffff" : "#212529")

      nameLines.forEach((line, index) => {
        const tspan = document.createElementNS("http://www.w3.org/2000/svg", "tspan")
        tspan.setAttribute("x", px)
        tspan.setAttribute("dy", index === 0 ? "0" : lineHeight)
        tspan.textContent = line
        text.appendChild(tspan)
      })

      let subText = null
      if (lifeDates) {
        subText = document.createElementNS("http://www.w3.org/2000/svg", "text")
        subText.setAttribute("x", px)
        subText.setAttribute("y", firstLineY + nameLines.length * lineHeight)
        subText.setAttribute("text-anchor", "middle")
        subText.setAttribute("font-size", "11")
        subText.setAttribute("fill", isRoot ? "#e9ecef" : "#6c757d")
        subText.textContent = lifeDates
      }

   

      // walks ancestors upward, and also walks back toward the starting/root person. It should not highlight every random cousin/sibling branch.
      const highlightConnected = () => {
      const edgeKey = (edge) => `${edge.source}->${edge.target}`

      const depthFor = (id) => {
        const match = data.nodes.find((n) => String(n.id) === String(id))
        return match ? (match.depth || 0) : null
      }

  const highlightedEdgeKeys = new Set()
  const visitedAncestorIds = new Set()
  const visitedTowardRootIds = new Set()

  const walkAncestors = (personId) => {
    const id = String(personId)
    if (visitedAncestorIds.has(id)) return
    visitedAncestorIds.add(id)

    edgeElements.forEach(({ edge }) => {
      if (String(edge.target) === id) {
        highlightedEdgeKeys.add(edgeKey(edge))
        walkAncestors(edge.source)
      }
    })
  }

  const walkTowardRoot = (personId) => {
    const id = String(personId)
    if (visitedTowardRootIds.has(id)) return
    visitedTowardRootIds.add(id)

    const currentDepth = depthFor(id)

    edgeElements.forEach(({ edge }) => {
      if (String(edge.source) !== id) return

      const targetDepth = depthFor(edge.target)

      if (currentDepth !== null && targetDepth !== null && targetDepth < currentDepth) {
        highlightedEdgeKeys.add(edgeKey(edge))
        walkTowardRoot(edge.target)
      }
    })
  }

  walkAncestors(node.id)
  walkTowardRoot(node.id)

  edgeElements.forEach(({ edge, line, baseStroke, baseStrokeWidth }) => {
    const inHighlightedPath = highlightedEdgeKeys.has(edgeKey(edge))

    if (inHighlightedPath) {
      const edgeLineageIds = edge.lineage_ids || []
      const edgeLineageCount = edgeLineageIds.length
      const edgeIsSelected = inSelectedOverlay(edgeLineageIds)

      line.setAttribute("stroke", edgeLineageCount > 0 ? "#9fb0bf" : "#d8dee6")
      line.setAttribute("stroke-width", edgeIsSelected ? "2.2" : "1.1")
      line.style.opacity = edgeIsSelected ? "0.8" : "0.12"

      line.setAttribute(
        "stroke-width",
        edgeLineageCount > 1 ? "3.5" : edgeLineageCount === 1 ? "3" : "2"
      )

      ;[edge.source, edge.target].forEach((personId) => {
        const connectedNode = nodeElements[personId]

        if (connectedNode) {
          connectedNode.circle.setAttribute("stroke", "#495057")
          connectedNode.circle.setAttribute("stroke-width", "2")
        }
      })
    } else {
      line.setAttribute("stroke", baseStroke)
      line.setAttribute("stroke-width", baseStrokeWidth)
    }
  })
}

      const resetConnected = () => {
        edgeElements.forEach(({ line, baseStroke, baseStrokeWidth }) => {
          line.setAttribute("stroke", baseStroke)
          line.setAttribute("stroke-width", baseStrokeWidth)
        })

        Object.keys(nodeElements).forEach((id) => {
          const entry = nodeElements[id]
          const nodeData = data.nodes.find((n) => String(n.id) === String(id))
          if (!entry || !nodeData) return

          const nodeLineageCount = (nodeData.lineage_ids || []).length

          const resetPrimaryLineageId =
            nodeLineageCount === 1 ? String(nodeData.lineage_ids[0]) : null
          const resetPrimaryColors = resetPrimaryLineageId ? lineageColors[resetPrimaryLineageId] : null

          if (nodeData.root) {
            entry.circle.setAttribute("stroke", "#0f6f83")
            entry.circle.setAttribute("stroke-width", "2.5")
          } else if (nodeLineageCount > 1) {
            entry.circle.setAttribute("stroke", "#f59f00")
            entry.circle.setAttribute("stroke-width", "3")
          } else if (nodeLineageCount === 1 && resetPrimaryColors) {
            entry.circle.setAttribute("stroke", resetPrimaryColors.stroke)
            entry.circle.setAttribute("stroke-width", "2")
          } else {
            entry.circle.setAttribute("stroke", "#adb5bd")
            entry.circle.setAttribute("stroke-width", "1")
          }
        })
      }

      const hoverOn = (event) => {
      if (isRoot) {
        circle.setAttribute("fill", "#1291ab")
        circle.setAttribute("filter", "drop-shadow(0 0 18px rgba(22,167,197,0.95))")
      } else if (lineageCount > 1) {
        circle.setAttribute("fill", "#ffe8a1")
        circle.setAttribute("filter", "drop-shadow(0 0 6px rgba(245,159,0,0.35))")
      } else if (lineageCount === 1 && primaryColors) {
        circle.setAttribute("fill", primaryColors.hoverFill)
        circle.setAttribute("filter", "drop-shadow(0 0 6px rgba(0,0,0,0.12))")
      } else {
        circle.setAttribute("fill", "#e9ecef")
        circle.setAttribute("filter", "drop-shadow(0 0 4px rgba(0,0,0,0.10))")
      }

        highlightConnected()
        showTooltip(event, node)
      }

      const hoverMove = (event) => {
        moveTooltip(event)
      }

      const hoverOff = () => {
        circle.setAttribute("fill", baseFill)

        if (isRoot) {
          circle.setAttribute("filter", "drop-shadow(0 0 14px rgba(22,167,197,0.85))")
        } else {
          circle.setAttribute("filter", "none")
        }

        resetConnected()
        hideTooltip()
      }

      nodeGroup.appendChild(hit)
      nodeGroup.appendChild(circle)

      const alwaysShowLabel = true
      text.style.display = alwaysShowLabel ? "block" : "none"
      if (subText) subText.style.display = alwaysShowLabel ? "block" : "none"

      text.addEventListener("mouseenter", hoverOn)
      text.addEventListener("mousemove", hoverMove)
      text.addEventListener("mouseleave", hoverOff)

      text.style.cursor = "pointer"
      text.addEventListener("click", openPerson)

     if (subText) {
 
        subText.style.cursor = "pointer"
        subText.addEventListener("click", openPerson)
        subText.addEventListener("mouseenter", hoverOn)
        subText.addEventListener("mousemove", hoverMove)
        subText.addEventListener("mouseleave", hoverOff)
      }

      hit.addEventListener("mouseenter", (event) => {
        text.style.display = "block"
        if (subText) subText.style.display = "block"
        hoverOn(event)
      })

      hit.addEventListener("mousemove", hoverMove)

      hit.addEventListener("mouseleave", () => {
        if (!alwaysShowLabel) {
          text.style.display = "none"
          if (subText) subText.style.display = "none"
        }
        hoverOff()
      })
 
      if (profileImageBorder) {
          nodeGroup.appendChild(profileImageBorder)
        }

        if (profileImage) {
          nodeGroup.appendChild(profileImage)
        }
            nodeGroup.appendChild(text)

      if (subText) {
        nodeGroup.appendChild(subText)
      }

      g.appendChild(nodeGroup)
      })

    updateTransform()

    svg.addEventListener("wheel", (event) => {
      event.preventDefault()

      const zoomFactor = 0.001
      scale += event.deltaY * -zoomFactor
      updateTransform()
    })

    svg.addEventListener("mousedown", (event) => {
      isDragging = true
      dragMoved = false
      svg.style.cursor = "grabbing"
      startX = event.clientX - translateX
      startY = event.clientY - translateY
    })

    svg.addEventListener("mousemove", (event) => {
      if (!isDragging) return

      const nextX = event.clientX - startX
      const nextY = event.clientY - startY

      if (Math.abs(nextX - translateX) > 3 || Math.abs(nextY - translateY) > 3) {
        dragMoved = true
      }

      translateX = nextX
      translateY = nextY
      updateTransform()
    })

    svg.addEventListener("mouseup", () => {
      isDragging = false
      svg.style.cursor = "grab"
    })

    svg.addEventListener("mouseleave", () => {
      isDragging = false
      svg.style.cursor = "grab"
      hideTooltip()
    })



  let graphArea = container.querySelector(".graph-area")

if (!graphArea) {
  graphArea = document.createElement("div")
  graphArea.className = "graph-area"
  container.appendChild(graphArea)
}

graphArea.style.overflow = "visible"
graphArea.innerHTML = ""
graphArea.appendChild(legend)
graphArea.appendChild(svg)

  }

  centerGraphViewport(container) {
  if (!container) return

  requestAnimationFrame(() => {
    const scrollWidth = container.scrollWidth || 0
    const clientWidth = container.clientWidth || 0

    if (scrollWidth > clientWidth) {
      container.scrollLeft = Math.max((scrollWidth - clientWidth) / 2, 0)
    }
  })
}
fitGraphToVisibleContent(container) {
  if (!container) return

  requestAnimationFrame(() => {
    const svg = container.querySelector("svg")
    if (!svg) return

    const group = svg.querySelector("g")
    if (!group || typeof group.getBBox !== "function") return

    const box = group.getBBox()
    if (!box || box.width === 0 || box.height === 0) return

    const padding = 80
    const viewBox = [
      box.x - padding,
      box.y - padding,
      box.width + padding * 2,
      box.height + padding * 2
    ].join(" ")

    // svg.setAttribute("viewBox", viewBox)
    // svg.setAttribute("width", "100%")
    // svg.setAttribute("height", "900")

    // container.scrollLeft = 0
    // container.scrollTop = 0
    // CP 95
    svg.setAttribute("viewBox", viewBox)
    svg.setAttribute("width", box.width + padding * 2)
    svg.setAttribute("height", box.height + padding * 2)

    svg.style.width = `${box.width + padding * 2}px`
    svg.style.height = `${box.height + padding * 2}px`

    container.scrollLeft = 0
    container.scrollTop = 0
      })
}
}
// See notes graph_explorer_controller_notes.md in docs/

// How it fits together (quick mental model)

// Think of it like this:

// 1. SVG = the canvas
// const svg = ...

// This is the outer container.

// 2. <g> = the movable layer

// Right after that you have:

// const g = document.createElementNS("http://www.w3.org/2000/svg", "g")
// svg.appendChild(g)

// 👉 This is super important:

// all nodes + edges go inside g
// zoom + pan happens by transforming g, not svg
// 3. You draw everything into g
// edges:
// g.appendChild(line)
// nodes:
// g.appendChild(nodeGroup)
// 4. Then you attach SVG to the page

// At the end:

// container.appendChild(svg)